import { SimAlertIcon } from './SimAlertIcon';

/**
 * author: Google
 * id 43CD286A-D183-474F-9B8A-93D43A355117
 * name sim-alert
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sim-alert.svg
 * tags
 * - Alert / Error 
 * - Cellphone / Phone 
 */
export const SimCardAlertIcon = SimAlertIcon;
export default SimCardAlertIcon